enum DropdownButtonTypeEnum {
  BUTTON,
  ICON,
}

export default DropdownButtonTypeEnum;
